import React, {Component} from 'react';
import './mapModal.component.sass';
import {connect} from "react-redux";
import * as L from "leaflet";
import {Button, Modal} from "rsuite";
import {createStructuredSelector} from "reselect";
import {selectFirstPin, selectRepresentationModal} from "../../redux/modals/modals.selector";
import ModalTypes from "../../redux/modals/modals.types";
import pinOrange from "../../assets/image/icons/pinOrange.png";
import { SetLatLng} from "../../redux/site/site.actions";
import {selectLatlng, selectMarkerLayer} from "../../redux/site/site.selector";
import SiteTypes from "../../redux/site/site.types";
import FindLocation from '../../assets/image/icons/FindLocation.png';
import 'leaflet-easybutton'

class MapModalComponent extends Component {
    componentDidMount() {
        const {ToggleFirstPin, setLatLng, FirstPin} = this.props;
        const Center = [32.951302, 53.652285];
        let icon = L.icon({
            iconUrl: pinOrange,
            iconAnchor: [15, 40],
            popupAnchor: [0, -20],
            iconSize: new L.Point(30, 40)
        });
        const firstmap = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 19,
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        });
        setTimeout(() => {
            const map = L.map('map', {
                center: Center,
                zoom: 5,
                maxZoom: 18,
                layers: [firstmap]
            });

            let marker = L.marker(Center, {
                icon: icon
            });

            L.easyButton(`<img src=${FindLocation} alt="My location" class="img-easy-button"/>`, () => {
                map.locate().on('locationfound', (e) => {
                    if (FirstPin) {
                        marker.setLatLng([e.latitude, e.longitude]).addTo(map);
                        map.flyTo([e.latitude, e.longitude], 13);
                        setLatLng([e.latitude.toFixed(6), e.longitude.toFixed(6)]);
                        ToggleFirstPin();
                    } else {
                        marker.setLatLng([e.latitude, e.longitude]);
                        setLatLng([e.latitude.toFixed(6), e.longitude.toFixed(6)]);
                        map.flyTo([e.latitude, e.longitude], 13)
                    }
                });
            }, 'Search Current Results within drawn layers', {position: 'topright'}).addTo(map);

            map.on('click', (x)=>{
                if(!FirstPin){
                    ToggleFirstPin();
                }
                let latlang = [x.latlng.lat, x.latlng.lng];
                marker.setLatLng(latlang).addTo(map);
                let lat = marker.getLatLng().lat.toFixed(6);
                let lng = marker.getLatLng().lng.toFixed(6);
                setLatLng([lat, lng])
            });

        }, 200)
    }

    render() {
        const {mapModal, ToggleMapModal} = this.props;
        return (
            <div className='map-modal'>
                <Modal size='xs' show={mapModal} onHide={() => ToggleMapModal()}>
                    <Modal.Header>
                        <Modal.Title>انتخاب لوکیشن نمایندگی</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div id='map' style={{height: '200px', width: '100%'}}/>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={() => ToggleMapModal()} appearance="primary">
                            تایید
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    mapModal: selectRepresentationModal,
    getLatlng: selectLatlng,
    getMarkerLayer: selectMarkerLayer,
    FirstPin: selectFirstPin
});
const mapDispatchToProps = dispatch => ({
    ToggleMapModal: () => dispatch({type: ModalTypes.TOGGLE_REPRESENTATION_MODAL}),
    setLatLng: latlng => dispatch(SetLatLng(latlng)),
    ClearMarkers : ()=> dispatch({type: SiteTypes.CLEAR_MARKERS}),
    ToggleFirstPin: ()=> dispatch({type: ModalTypes.TOGGLE_FIRST_PIN})
});

export default connect(mapStateToProps, mapDispatchToProps)(MapModalComponent);